import SeoValueObjectsFactory from '../../seo/ValueObjects/factory.js'
import NewsEntitiesFactory from '../Entities/factory.js'
import NewsValueObjectsFactory from '../ValueObjects/factory.js'
import ArticleJSONToArticleEntityMapper from './ArticleJSONToArticleEntityMapper.js'
import {FromNewsDetailResponseToEntityMapper} from './FromNewsDetailResponseToEntityMapper.js'
import {FromTagsListToFormattedTagsListNewsValueObjectMapper} from './FromTagsListToFormattedTagsListNewsValueObjectMapper.js'
import {FromTagToFormattedTagNewsValueObjectMapper} from './FromTagToFormattedTagNewsValueObjectMapper.js'

export default class NewsMappersFactory {
  static articleJSONToArticleEntityMapper = ({config}) =>
    new ArticleJSONToArticleEntityMapper({
      config,
      articleEntityFactory: NewsEntitiesFactory.articleEntity,
      articleImageEntityFactory: NewsEntitiesFactory.articleImageEntity,
      tagEntityFactory: NewsEntitiesFactory.tagEntity
    })

  static fromTagsListToFormattedTagsListNewsValueObjectMapper = ({config}) =>
    new FromTagsListToFormattedTagsListNewsValueObjectMapper({
      config,
      fromTagToFormattedTagNewsValueObjectMapper: NewsMappersFactory.fromTagToFormattedTagNewsValueObjectMapper({
        config
      }),
      newsTagsListValueObjectFactory: NewsValueObjectsFactory.newsTagsListValueObject
    })

  static fromTagToFormattedTagNewsValueObjectMapper = ({config}) =>
    new FromTagToFormattedTagNewsValueObjectMapper({
      config,
      newsTagValueObjectFactory: NewsValueObjectsFactory.newsTagValueObject
    })

  static fromNewsDetailResponseToEntityMapper = ({config}) =>
    new FromNewsDetailResponseToEntityMapper({
      config,
      newsDetailEntityFactory: NewsEntitiesFactory.articleDetailEntity,
      authorEntityFactory: NewsEntitiesFactory.authorEntity,
      tagcloudSeoValueObjectFactory: SeoValueObjectsFactory.tagcloudSeoValueObject({
        config
      }),
      tagEntityFactory: NewsEntitiesFactory.tagEntity
    })
}
